import DynamicContent from "../../../../../components/login/DynamicLoginContent";
import InteractiveDashboard from "../../components/InteractiveDashboard";
import MicroNews from "../Widgets/microWidgets/MicroNews";
import Notes from "../Widgets/StickyNotesComponent";
import WebsiteAnalytics from '../Widgets/WebsiteAnalytics';
import WelcomeWidget from '../Widgets/WelcomeWidget';
import MicroNotes from "../Widgets/microWidgets/MicroNotes";
import MicroWelcome from '../Widgets/microWidgets/MicroWelcome';
import MicroAnalytics from '../Widgets/microWidgets/MicroAnalytics';
import MicroReports from "../Widgets/microWidgets/MicroReports";
import FeedWidget from '../Widgets/FeedWidget';
import News from '../Widgets/News';
import Meetings from "../../CalendarScreen/Meetings";
import { Platform, Text, View, Image } from 'react-native'
import LottieView from 'lottie-react-native';
import AIActions from '../Widgets/AIActions';
import FlaggedWidget from '../Widgets/FlaggedWidget';

const WidgetList = [
  // {
  //   id: 1,
  //   widget: <WelcomeWidget />,
  //   smallWidget: <View style={{ top: -15, flex: 1 }}><Image source={require("@assets/images/widgets/report-dash.png")} style={{ width: 100, height: 100,  }} /></View>,
  //   removeFor: [],
  //   label: 'Dashboard'
  // },
  {
    id: 0,
    widget: <FeedWidget />,
    smallWidget: <View style={{ top: -15, flex: 1 }}>
      <Image source={require("@assets/images/widgets/home.png")} style={{ width: 85, height: 85,  }} />
    </View>,
    removeFor: [],
    label: 'Feed'
  },
  {
    id: 2,
    widget: <AIActions />,
    smallWidget: <View style={{ top: -15, flex: 1 }}><LottieView autoPlay source={require('@assets/animations/automation_robot.json')} style={{ width: 100, height: 100,  }}></LottieView></View>,
    removeFor: [],
    label: 'AI'
  },
  {
    id: 3,
    widget: <Notes />,
    // widget: <Text>COMING SOON</Text>,
    smallWidget: <View style={{ top: -15, flex: 1 }}><Image source={require("@assets/images/widgets/notes.png")} style={{ width: 100, height: 100,  }} /></View>,
    removeFor: [],
    label: 'Notes'
  },
  {
    id: 4,
    // widget: <Text>COMING SOON</Text>,
    widget: <View style={{ paddingHorizontal: "6%" }}><Meetings widget /></View>,
    smallWidget: <View style={{ top: -15, flex: 1 }}><Image source={require("@assets/images/widgets/meetings.png")} style={{ width: 100, height: 100,  }} /></View>,
    removeFor: [],
    label: "Meetings"
  },
  {
    id: 5,
    widget: <FlaggedWidget />,
    smallWidget: <View style={{ top: -15, flex: 1 }}><Image source={require("@assets/images/widgets/flagged.png")} style={{ width: 100, height: 100,  }} /></View>,
    removeFor: [],
    label: "Flagged"
  }
  // {
  //   id: 4,
  //   widget: <News />,
  //   smallWidget: <View style={{top: -15, flex: 1}}><Image source={require("@assets/images/widgets/news.png")} style={{ width: 100, height: 100 }} /></View>,
  //   removeFor: [],
  //   label: 'News'
  // },
  // {
  //   id: 6,
  //   widget: <AchievementWidget />,
  //   smallWidget: <View style={{top: -15, flex: 1}}><Image source={require("@assets/images/widgets/trophy.png")} style={{ width: 100, height: 100 }} /></View>,
  //   removeFor: [],
  //   label: 'Trophies'
  // },
  
  // {
  //   id: 6,
  //   widget: <WebsiteAnalytics />,
  //   smallWidget: <MicroAnalytics />,
  //   removeFor: []
  // },
  // {
  //   id: 7,
  //   widget: <MicroReports />,
  //   smallWidget: <MicroReports />,
  //   removeFor: ['web'],
  //   label: 'Recents'

  // }
]

export default WidgetList;